import { render } from "./FraudSelfCheck.vue?vue&type=template&id=73d9288a&scoped=true"
import script from "./FraudSelfCheck.vue?vue&type=script&lang=js"
export * from "./FraudSelfCheck.vue?vue&type=script&lang=js"

import "./FraudSelfCheck.vue?vue&type=style&index=0&id=73d9288a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d9288a"]])

export default __exports__